<template>
  <div class="couserwareAnalysis">
    <div class="header">
      <el-row :gutter="2" type="flex">
        <el-col :span="9"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{
              startDate: searchForm.startDate,
              endDate: searchForm.endDate
            }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="6"
          ><span class="title">省市区:</span>
          <el-cascader
            :options="options"
            :props="{ multiple: true }"
            v-model="cityValue"
            collapse-tags
            clearable
            @change="cityChange"
            @visible-change="cityVisible"
            @remove-tag="removeTag"
          ></el-cascader
        ></el-col>
        <el-col :span="6"
          ><span class="title">学校:</span
          ><filterSelect ref="filterSelect" :optionsList="schoolList" @checked="schoolChecked"
        /></el-col>
        <!-- <el-col :span="6"
          ><span class="title">学校名称:</span
          ><filterSelect :optionsList="schoolList" @checked="schoolChecked"
        /></el-col> -->

        <el-col :span="3"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search">查询</el-button>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          课件分析
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="KJFX"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel" :loading="downLoading">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          v-if="!emptyIsShow"
          :data="tableData"
          :key="keytable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'teaTotal', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed prop="schoolName" label="学校名称" width="220"> </el-table-column>
          <el-table-column sortable="custom" prop="teaTotal" label="教师总数" width="120"> </el-table-column>
          <el-table-column sortable="custom" prop="upLoadCourseWareTeaNum" label="上传课件教师数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="upLoadCourseWareTeaPent" label="上传课件教师占比" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="perUpLoadCourseWareNum" label="人均上传课件数 " width="150">
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="prepareLessonUseCourseWareNum"
            label="使用课件备课教师数"
            width="170"
          >
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="prepareLessonUseCourseWarePent"
            label="使用课件备课教师占比"
            width="170"
          >
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="perAvgPrepareLessonUseCourseWareNum"
            label="人均备课使用课件数"
            width="170"
          >
          </el-table-column>
          <el-table-column sortable="custom" prop="inClassUseCourseWareNum" label="使用课件授课教师数" width="170">
          </el-table-column>
          <el-table-column sortable="custom" prop="inClassUseCourseWarePent" label="使用课件授课教师占比" width="170">
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="perAvgInClassUseCourseWareNum"
            label="人均授课使用课件数"
            width="170"
          >
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="auto">
            <template slot-scope="scope">
              <el-button type="text" class="detail-btn" @click="goDetail(scope.row)">教师明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-if="emptyIsShow" description="暂无数据" :image-size="80" style="margin-top: 100px"></el-empty>
      </div>
      <div class="pagSize" v-if="!emptyIsShow">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from '../../components/FilterSelect/index.vue'
import datePicker from '../../components/datePicker/index.vue'
// import newDate from "../../components/newDate";
import { KJFX } from '@/utils/explainText.js'
import { calculate } from '@/utils/number.js'
import { lastWeek } from '@/utils/date.js'
// import { saveAs } from 'file-saver'
import fileSave from '@/utils/fileSave.js'

import { courseWareList } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { resize } from '@/mixins/resize.js'
export default {
  name: 'CouserwareAnalysis',
  mixins: [resize],
  components: {
    filterSelect,
    // newDate,
    datePicker
  },
  data() {
    return {
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      KJFX: KJFX,
      loading: false,
      emptyIsShow: false,
      total: 0,
      searchForm: {
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        schoolIds: [],
        pageNum: 1,
        pageSize: 12,
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        sortCode: 'teaTotal',
        ascOrDes: false
      },
      tableData: [],
      options: JSON.parse(sessionStorage.getItem('cityList')),
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      cityValue: [],
      keytable: 0,
      downLoading: false
    }
  },
  created() {
    this.getList()
    // this.getSchools();
  },
  activated() {
    window.addEventListener('resize', this.tableLayout)
    this.tableLayout()
  },
  deactivated() {
    window.removeEventListener('resize', this.tableLayout)
  },
  mounted() {},
  methods: {
    // 日期选择
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
    },
    // 学校选择器事件
    schoolChecked(v) {
      // console.log(v, "schoolChecked");
      this.searchForm.schoolId = []
      v.forEach((el) => {
        this.searchForm.schoolId.push(el.value)
      })
    },

    // 重置
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.$refs.filterSelect.checkedValue = ''
      this.cityValue = []
      this.address = this.$options.data().address
      this.keytable += 1
      this.schoolList = JSON.parse(sessionStorage.getItem('schoolList'))
      this.getList()
    },
    //查询
    search() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 排序
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        this.getList()
      }
    },
    getList() {
      this.loading = true
      this.$API.couserwareAnalysisApi
        .getCouserware(this.searchForm)
        .then((res) => {
          // console.log(res);
          this.tableData = res.result
          if (this.tableData.length > 0) {
            this.emptyIsShow = false
            this.total = this.tableData[0].total
            this.tableData.forEach((el) => {
              el.upLoadCourseWareTeaPent = el.upLoadCourseWareTeaPent + '%'
              el.inClassUseCourseWarePent = el.inClassUseCourseWarePent + '%'
              el.prepareLessonUseCourseWarePent = el.prepareLessonUseCourseWarePent + '%'
              // if (el.teaTotal === 0) {
              //   el.upLoadCourseWareTeaNumPre =
              //     el.prepareLessonUseCourseWareNumPre =
              //     el.inClassUseCourseWareNumPre =
              //       0;
              //   return;
              // }
              // el.upLoadCourseWareTeaNumPre = calculate(
              //   el.upLoadCourseWareTeaNum,
              //   el.teaTotal
              // );
              // el.prepareLessonUseCourseWareNumPre = calculate(
              //   el.prepareLessonUseCourseWareNum,
              //   el.teaTotal
              // );
              // el.inClassUseCourseWareNumPre = calculate(
              //   el.inClassUseCourseWareNum,
              //   el.teaTotal
              // );
            })
          } else {
            this.total = 0
            this.emptyIsShow = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 学校选择器事件
    schoolChecked(v) {
      // console.log(v, "schoolChecked");
      this.searchForm.schoolIds = []
      // if (v.length < 1) {
      //   this.schoolList.forEach((el) => {
      //     this.searchForm.schoolIds.push(el.value);
      //   });
      //   return;
      // }
      v.forEach((el) => {
        this.searchForm.schoolIds.push(el.value)
      })
    },
    // 省市区选择器
    cityChange(v) {
      this.address = this.$options.data().address
      this.searchForm.provinceIds = this.searchForm.cityIds = this.searchForm.localeIds = []
      if (v.length < 1) {
        this.getSchools()
      }
      v.forEach((el) => {
        this.address.provinceIds.push(el[0])
        this.searchForm.provinceIds = this.address.provinceIds
        this.address.cityIds.push(el[1])
        this.searchForm.cityIds = this.address.cityIds
        this.address.localeIds.push(el[2])
        this.searchForm.localeIds = this.address.localeIds
      })
    },
    removeTag(v) {
      // console.log(v);
      let i = this.address.provinceIds.findIndex((el) => el == v[0])
      this.address.provinceIds.splice(i, 1)
      this.address.cityIds.splice(i, 1)
      this.address.localeIds.splice(i, 1)
      if (this.address.provinceIds.length > 0) {
        this.getSchools()
      }
    },
    // 省市区选择器收起时
    cityVisible(v) {
      if (!v && this.address.provinceIds.length > 0) {
        // console.log("请求");
        this.getSchools()
      }
    },
    getSchools() {
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        // console.log(res);
        this.$refs.filterSelect.checkedValue = ''
        // this.$refs.filterSelect.uncertainCheckedList = [];
        this.searchForm.schoolIds = []
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    },
    // 教师明细
    goDetail(v) {
      let info = {
        schoolId: v.schoolId,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate
      }
      this.$router.push({
        name: 'CouserwareTecDeatil',
        query: info
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.searchForm.pageNum = val
      this.getList()
    },
    // 导出表格
    downExcel() {
      this.downLoading = true

      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum
      obj.fileName = excelName('学校课件使用分析', obj.startDate, obj.endDate)
      fileSave(courseWareList + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
        this.downLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.couserwareAnalysis {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
